__turbopack_context__.v({
  "backgroundCard": "Reviews-module__D9cgpa__backgroundCard",
  "backgroundCard2": "Reviews-module__D9cgpa__backgroundCard2",
  "backgroundText": "Reviews-module__D9cgpa__backgroundText",
  "featuredCard": "Reviews-module__D9cgpa__featuredCard",
  "headerContainer": "Reviews-module__D9cgpa__headerContainer",
  "headerText": "Reviews-module__D9cgpa__headerText",
  "playButton": "Reviews-module__D9cgpa__playButton",
  "profile": "Reviews-module__D9cgpa__profile",
  "profileMedium": "Reviews-module__D9cgpa__profileMedium",
  "profileSmall": "Reviews-module__D9cgpa__profileSmall",
  "profileTiny": "Reviews-module__D9cgpa__profileTiny",
  "radial": "Reviews-module__D9cgpa__radial",
  "reviewCard": "Reviews-module__D9cgpa__reviewCard",
  "reviewText": "Reviews-module__D9cgpa__reviewText",
  "reviewsContainer": "Reviews-module__D9cgpa__reviewsContainer",
  "section": "Reviews-module__D9cgpa__section",
  "userInfo": "Reviews-module__D9cgpa__userInfo",
  "userName": "Reviews-module__D9cgpa__userName",
  "userNameMedium": "Reviews-module__D9cgpa__userNameMedium",
  "userNameSmall": "Reviews-module__D9cgpa__userNameSmall",
  "userNameTiny": "Reviews-module__D9cgpa__userNameTiny",
  "video": "Reviews-module__D9cgpa__video",
  "videoCard": "Reviews-module__D9cgpa__videoCard",
  "videoContainer": "Reviews-module__D9cgpa__videoContainer",
});
